$(function() {
    $('.product-container .prompt-delivery')
        .siblings('label')
        .toArray()
            .forEach(el => el.click())
});